import { Instant, LocalDate, LocalDateTime } from "@js-joda/core";
import * as messages from "../../messages";
import {
  CaregiverId,
  Geo,
  MethodType,
  PatientTask,
  PatientTaskInstanceId,
  TaskDayTimeParams,
  VisitInstanceDetails,
  VisitInstanceId,
} from "../../messages";
import { genericUpdate } from "../../utils/generic_update";
import { KeyedList } from "../../utils/List";

export interface AppTasksState {
  readonly tasks: KeyedList<PatientTaskInstance, "id">;
}

export type PatientTaskInstance =
  | PatientTaskInstance.COMPLETED
  | PatientTaskInstance.PENDING
  | PatientTaskInstance.SCHEDULED;

export declare namespace PatientTaskInstance {
  export interface COMPLETED extends BaseDetails {
    type: "COMPLETED";
    completionDate: LocalDate;
    scheduleDateTime: Instant;
    dayTimeParams: TaskDayTimeParams;
    visitInstance: VisitInstanceDetails | null;
    patientConfirmedSchedule: boolean;
  }

  export interface SCHEDULED extends BaseDetails {
    type: "SCHEDULED";
    completionDate: null;
    scheduleDateTime: Instant;
    dayTimeParams: TaskDayTimeParams;
    visitInstance: VisitInstanceDetails | null;
    patientConfirmedSchedule: boolean;
  }

  export interface PENDING extends BaseDetails {
    type: "PENDING";
    completionDate: null;
    scheduleDateTime: null;
    dayTimeParams: TaskDayTimeParams;
  }

  interface BaseDetails {
    id: PatientTaskInstanceId;
    visitInstanceId: VisitInstanceId | null;
    caregiverId: CaregiverId;
    startDate: LocalDate;
    dueDate: LocalDate;
    taskDetails: PatientTask;
    clockInTime: LocalDateTime | null;
    clockOutTime: LocalDateTime | null;
    clockInLocation: Geo | null;
    clockOutLocation: Geo | null;
    clockInType: MethodType | null;
    clockOutType: MethodType | null;
  }

  export interface COMPLETEDVISITUNION extends COMPLETED {
    union_type: "TASK";
  }

  export interface SCHEDULEDVISITUNION extends SCHEDULED {
    union_type: "TASK";
  }

  export interface PENDINGVISITUNION extends PENDING {
    union_type: "TASK";
  }
}

export class AppTasksState {
  static fromMessage(message: messages.PatientTaskInstancesList): AppTasksState {
    let tasks = KeyedList.empty<PatientTaskInstance>()("id");

    message.tasks.forEach((task) => {
      tasks = tasks.append(task);
    });

    return {
      tasks: tasks,
    };
  }

  static updateFromMessage(
    appTasksState: AppTasksState,
    message: messages.PatientTaskInstancesList
  ): AppTasksState {
    return genericUpdate(appTasksState, AppTasksState.fromMessage(message));
  }
}
